import Link from "@/components/ui/Link";
import { getIconUrl } from "@/lib/directus";
import Image from "next/image";

export interface BlogAuthorListSectionData {
  posts?: any[];
  total?: number;
  authorSlug?: string;
  totalPages?: number;
  currentPage?: number;
  left_column_data?: any;
  author?: {
    id?: string;
    slug: string;
    title: string;
    subtitle?: string;
    description?: string;
    bio?: string;
    avatar?: string | null;
  } | null;
}

interface BlogAuthorListSectionProps {
  data: BlogAuthorListSectionData;
}

export default function BlogAuthorListSection({
  data,
}: BlogAuthorListSectionProps) {
  const author = data.author;
  const authorName = author?.title || 'Dr. Jeffrey Harmon';
  const authorSubtitle = author?.subtitle || 'Facial Plastic Surgeon, Cincinnati, Ohio';
  const authorBio = author?.description || author?.bio || null;

  const avatarUrl =
    author?.avatar && typeof author.avatar === 'string'
      ? getIconUrl(author.avatar)
      : null;

  return (
    <section className="py-20 md:py-28 bg-neutral-50">
      <div className="container mx-auto max-w-[860px] px-6">
        <div className="flex flex-col md:flex-row items-center md:items-start gap-12 md:gap-16">

          {avatarUrl && (
            <div className="flex-shrink-0">
              <div className="relative w-48 h-48 md:w-60 md:h-60 rounded-full overflow-hidden shadow-lg ring-[5px] ring-primary/25">
                <Image
                  src={avatarUrl}
                  alt={authorName}
                  fill
                  className="object-cover"
                  quality={95}
                />
              </div>
            </div>
          )}

          <div className="flex-1 text-center md:text-left">
            <div className="flex items-center gap-3 justify-center md:justify-start mb-5">
              <span className="block w-8 h-px bg-primary" />
              <span className="text-xs uppercase tracking-[0.2em] text-primary font-brandon">
                About the Author
              </span>
            </div>

            <h1 className="font-freightBig text-4xl md:text-5xl text-navy mb-2 leading-tight">
              {authorName}
            </h1>

            <p className="text-sm uppercase tracking-[0.18em] text-gray-slate font-brandon mb-6">
              {authorSubtitle}
            </p>

            <div className="w-10 h-px bg-primary mx-auto md:mx-0 mb-6" />

            {authorBio && (
              <p className="text-gray-slate font-brandon font-light text-base leading-relaxed mb-8 max-w-lg mx-auto md:mx-0">
                {authorBio}
              </p>
            )}

            <Link
              href="/about-us/meet-dr-harmon"
              className="inline-flex items-center gap-2 text-sm font-brandon uppercase tracking-[0.15em] text-navy border-b border-primary pb-px hover:text-primary transition-colors duration-200"
            >
              Full credentials &amp; biography
              <span className="text-primary text-base">→</span>
            </Link>
          </div>

        </div>
      </div>
    </section>
  );
}
